import api from './index'

let exports = {};

//询价列表
exports.getPriceInqryVoucherList = function (params, callback) {// 查询询价单列表
    api.post('/price/inqry/voucher/list/get')
    .data(params)
    .done(callback)
    .go();
};

//询价申请
exports.applyPriceInqryVoucher = function (params, callback) {// 询价单申请
    api.post('/price/inqry/voucher/apply/do')
    .data(params)
    .done(callback)
    .go();
};

//询价审核
exports.auditPriceInqryVoucher = function (params, callback) {// 询价单审核
    api.post('/price/inqry/voucher/audit/do')
    .data(params)
    .done(callback)
    .go();
};

//询价发布
exports.publishPriceInqryVoucher = function (params, callback) {// 询价单发布
    api.post('/price/inqry/voucher/publish/do')
    .data(params)
    .done(callback)
    .go();
};

//询价关闭
exports.closePriceInqryVoucher = function (params, callback) {// 关闭询价单
    api.post('/price/inqry/voucher/close/do')
    .data(params)
    .done(callback)
    .go();
};

//关闭已过期所有询价
exports.closePriceInqryVoucherExpired = function (callback) {// 关闭全部已过期询价单
    api.post('/price/inqry/voucher/expired/close/do')
    .done(callback)
    .go();
};

//询价删除
exports.deletePriceInqryVoucher = function (params, callback) {// 删除询价单
    api.post('/price/inqry/voucher/delete/do')
    .data(params)
    .done(callback)
    .go();
};

//商品询价详情
exports.getPriceInqryVoucher = function (params, callback) {// 查询询价单详情
    api.post('/price/inqry/voucher/get')
    .data(params)
    .done(callback)
    .go();
};

//报价列表
exports.getPriceReplyVoucherList = function (params, callback) {// 查询报价列表
    api.post('/price/reply/voucher/list/get')
    .data(params)
    .done(callback)
    .go();
};

//报价详情
exports.getPriceReplyVoucherInfo = function (params, callback) {// 查询报价详情
    api.post('/price/reply/voucher/info/get')
    .data(params)
    .done(callback)
    .go();
};

//查询条款信息
exports.getPriceInqryTermList = function (params, callback) {// 查询询价条款信息
    api.post('/price/inqry/term/list/get')
    .data(params)
    .done(callback)
    .go();
};

//查询报价条款信息
exports.getPriceReplyTermList = function (params, callback) {// 查询报价条款信息
    api.post('/price/reply/term/list/get')
    .data(params)
    .done(callback)
    .go();
};

//采纳报价
exports.adoptPriceInqryVoucher = function (params, callback) {// 采纳报价单
    api.post('/price/reply/voucher/adopt/do')
    .data(params)
    .done(callback)
    .go();
};

//修改询价单tag
exports.updatePriceInqryVoucherToDelete = function (postData, callback) {// 修改询价单tag
    api.post('/price/reply/voucher/update/do')
    .data(postData)
    .done(callback)
    .go();
};

//报价商品列表
exports.getPriceReplyGoodsList = function (postData, callback) {// 查询报价商品列表
    api.post('/price/reply/goods/list/get')
    .data(postData)
    .done(callback)
    .go();
};

//查询询价商品详情
exports.getPriceInqryGoods = function (postData, callback) {// 查询询价商品详情
    api.post('/price/inqry/goods/get')
    .data(postData)
    .done(callback)
    .go();
};

//查询报价服务列表
exports.getPriceReplyServcList = function (postData, callback) {// 查询报价服务列表
    api.post('/price/reply/servc/list/get')
    .data(postData)
    .done(callback)
    .go();
};

///查询询价服务详情
exports.getPriceInqryServc = function (postData, callback) {// 查询询价服务详情
    api.post('/price/inqry/servc/get')
    .data(postData)
    .done(callback)
    .go();
};

///更新询价单
exports.updatePriceInqryVoucher = function (postData, callback) {// 更新询价单
    api.post('/price/inqry/voucher/update/do')
    .data(postData)
    .done(callback)
    .go();
};
///取消询价单来源
exports.cancelPriceInqryVoucherSrc = function (postParam, callback) {// 更新询价单
    api.post('/price/inqry/voucher/src/cancel/do')
    .params(postParam)
    .done(callback)
    .go();
};

//询价结束
exports.finishPriceInqryVoucher = function (params, callback) {// 关闭询价单
    api.post('/price/inqry/voucher/finish/do')
    .data(params)
    .done(callback)
    .go();
};

export default exports;


//////////////////
// WEBPACK FOOTER
// ./src/api/price.js
// module id = 96
// module chunks = 0